import React, { Suspense, useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router'
import MainLayout from '@/layouts/MainLayout'
import Loading from '@/components/Loading'
import { useStore } from './store'
import dayjs from 'dayjs'
import { useQueries, useQuery } from '@tanstack/react-query'
import { getUserMeOptions, getUserStateOptions, getUserRewardsOptions, getSiteOptions } from './client/@tanstack/react-query.gen'
import { useParamsOptions } from './models/Config'

const Home = React.lazy(() => import('@/pages/Home'))

const App = () => {
  const { updateState } = useStore()
  const config = useQueries({
    queries: [
      useParamsOptions(),
      getSiteOptions(),
    ],
    combine: results => {
      return {
        params: results?.[0]?.data,
      }
    }
  })

  const { data: userData, status } = useQuery({
    ...getUserMeOptions()
  })

  useQuery({
    ...getUserStateOptions(),
    enabled: !!userData?.id,
  })

  useQuery({
    ...getUserRewardsOptions(),
    enabled: !!userData?.id,
  })

  useEffect(() => {
    if (status == 'success' || status == 'error') {
      updateState('userLoaded', true)
    }
  }, [status, updateState])

  useEffect(() => {
    if (config?.params) {
      updateState('loaded', true)
      updateState('params', config?.params)
      updateState('delta', Number(dayjs(config?.params?.current).unix()) * 1000 - new Date().getTime())
      updateState('errors', config?.params?.errors)
    }
  }, [config?.params, updateState])

  //Preload needed information
  //End preload needed information

  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
        <MainLayout>
          <Routes>
            <Route path="/" element={
              <Home />
            }></Route>
            <Route path="*" element={
              <><div className="text-center">Oops! Not found!</div></>
            }></Route>
          </Routes>
        </MainLayout>
      </Suspense>
    </BrowserRouter>
  )
}

export default App